import { InjectionToken } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { ShoppingCartItem } from '../shopping-cart.types';

export interface ShoppingCartPaymentData {
  items: ShoppingCartItem<any>[];
  subtotal: number;
  tax: number;
  shipping: number;
  total: number;
  quoteRequestIDs?: number[];
}

export interface PaymentFormData {
  credit_card_number?: string;
  expiration_date?: string;
  credit_card_cvv?: string;
  payer_name?: string;
  useDefaultAddress?: boolean;
  address_street_1?: string;
  address_street_2?: string;
  address_city?: string;
  address_state_abbreviation?: string;
  address_zip?: string;
  selectedCardType?: string;
  paymentMethod?: string;
  quoteRequestIDs?: number[];
}

export interface PaymentProcessResult {
  success: boolean;
  transactionId?: string;
  error?: string;
  data?: any;
}

export interface ShoppingCartPaymentProvider {
  /**
   * Creates and returns the payment form group with validation
   */
  createPaymentForm(): FormGroup;

  /**
   * Processes the payment with the given form data and cart items
   */
  processPayment(formData: PaymentFormData, paymentData: ShoppingCartPaymentData): Observable<PaymentProcessResult>;

  /**
   * Validates card number and determines card type
   */
  validateCardNumber(cardNumber: string): { cardType: string; isValid: boolean };

  /**
   * Gets the required form field configuration
   */
  getFormFieldConfig(): PaymentFormFieldConfig;
}

export interface PaymentFormFieldConfig {
  requiresBillingAddress: boolean;
  requiresCardholderName: boolean;
  supportedCardTypes: string[];
  additionalFields?: string[];
}

export const SHOPPING_CART_PAYMENT_PROVIDER = new InjectionToken<ShoppingCartPaymentProvider>(
  'SHOPPING_CART_PAYMENT_PROVIDER'
);
